module.exports = __webpack_public_path__ + "img/price-network.98e1414e.webp";